import { lazy } from 'react';
import Attendance from './Attendance';
import AttendanceForm from './AttendanceForm';

const AttendanceConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/attendance',
            element: <Attendance />,
        },
        {
            path: '/addAttendance',
            element: <AttendanceForm />,
        },
        {
            path: '/editAttendance/:id',
            element: <AttendanceForm />,
        },
    ],
};

export default AttendanceConfig;
